import { render, staticRenderFns } from "./locale-changer.vue?vue&type=template&id=15f7ed94&scoped=true&"
import script from "./locale-changer.vue?vue&type=script&lang=js&"
export * from "./locale-changer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f7ed94",
  null
  
)

export default component.exports